import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { VnToast } from 'dida-web-common'
import './index.scss'
import * as Sentry from '@dida-sentry/h5'
import { BrowserTracing } from '@sentry/tracing'
import packageInfo from '../package.json'
import { BsGetEnv, BsUtil, BsTrack } from 'dida-web-common'

const channelType = BsUtil.queryString('channelType') || ''
const terminalType = BsUtil.queryString('terminalType') || ''
const activityCode = BsUtil.queryString('activityCode') || ''
const appId = BsUtil.queryString('appId') ||
  BsUtil.getQuery(location.hash.replace(/^#/, '')).appId || ''
const client = ''

Vue.use(VnToast)
window.myTrack = new BsTrack({
  name: '直接领券',
  waitTime: false
}, {
  activityCode: BsUtil.queryString('activityCode')
})
Vue.config.productionTip = false
if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue,
    release: packageInfo.name + '@' + packageInfo.version,
    environment: BsGetEnv.isEnvOnline ? 'online' : (BsGetEnv.isEnvECS ? 'simu' : 'test'),
    dsn: 'https://6d46d1215a664586a6c853baf4b50c08@sentry.didapinche.com/124',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'capis.didapinche.com', 'capis-ecs.didapinche.com', 'capis-test.didapinche.com']
      })
    ],
    tracesSampleRate: 1.0
  })
}
new Vue({
  router,
  data() {
    return {
      channelType,
      terminalType,
      activityCode,
      appId,
      client
      // cid: cid,
      // access_token: access_token
    }
  },
  render: h => h(App)
}).$mount('#app')
